import axios from 'axios';
import { core_backend_url } from '../config';

const axiosInstance = axios.create({
  baseURL: core_backend_url,
});

const http = {
    post: axiosInstance.post,
    put: axiosInstance.put,
    get: axiosInstance.get,
    delete: axiosInstance.delete,
    patch: axiosInstance.patch,
};

export const setAuthTokenHeader = (token) => {
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export default http;